
export function mailDraftListGet(page) {
	return {
    type: 'MAIL_DRAFT_LIST_GET',
		payload: {
			page: page,
		},
	}
}


export function mailDraftItemGet(pic, callback) {
	return {
    type: 'MAIL_DRAFT_ITEM_GET',
		payload: {
			pic: pic,
		},
		callback: callback,
	}
}

export function mailDraftSave(pic, mailText) {
	return {
    type: 'MAIL_DRAFT_SAVE',
		payload: {
			pic: pic,
			mailText: mailText,
		},
	}
}

export function mailDraftDel(pic) {
	return {
    type: 'MAIL_DRAFT_DEL',
		payload: {
			pic: pic,
		},
	}
}
